import { useState, useEffect } from 'react';

const TABLET_BREAKPOINT = 769;

const useIsMobile = (breakpoint = TABLET_BREAKPOINT) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenWidth < breakpoint;
};

export default useIsMobile;
